module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/default-banner-luxury-46d8d7c8bd84fc515f86deb6bf8b5af6.png";